import { AdminType, APIGet, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

export async function GetBookingsByCategory(
  params: { date: string },
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/client/admin/dashboard/data/booking-categories"),
    params,
    useGlobalLoader,
    cancelToken,
  );
}

export async function GetEvents(params: { date: string }, useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/client/admin/dashboard/data/events"),
    params,
    useGlobalLoader,
    cancelToken,
  );
}

export async function GetTeeTimesPlayerVolume(
  params: { date: string; division_ids: Array<number> },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/client/admin/dashboard/data/teetimes"),
    params,
    useGlobalLoader,
    token,
  );
}
